import { useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import layout from "../../../actprep-ui/constants/layout";
import TeamTree from "../../../components/TeamTree";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import TeamForm from "../../../components/TeamForm";
import RoleForm from "../../../components/RoleForm";
import AdminProfileForm from "../../../components/AdminProfileForm";

export default function CompanyTree() {
  const [selectedItem, setSelectedItem] = useState(null);
  return (
    <Grid
      sx={{
        mt: `${layout.navBarHeight + 1}rem`,
        mb: 4,
      }}
      size={12}
    >
      <Typography variant="h5" fontWeight={"bold"} my={2} color={"primary"}>
        Company Tree
      </Typography>
      <Grid container spacing={2}>
        <Grid size={selectedItem ? 6 : 12}>
          <ContentBox>
            <TeamTree onItemSelect={(item) => setSelectedItem(item)} />
          </ContentBox>
        </Grid>
        {selectedItem && (
          <Grid size={6}>
            <ContentBox>
              {selectedItem?.type == "team" && (
                <TeamForm teamId={selectedItem.id} />
              )}
              {selectedItem?.type == "role" && (
                <RoleForm roleId={selectedItem.id} />
              )}
              {selectedItem?.type == "admin_profile" && (
                <AdminProfileForm adminProfileId={selectedItem.id} />
              )}
            </ContentBox>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
